/* global $:false */

import htmx from 'htmx.org/dist/htmx.js'

export default class Boost {
  constructor (reinit) {
    this.reinit = reinit
    this._setup()
  }

  start (revision) {
    const gitRevisionOnLoad = revision

    htmx.on('htmx:afterSettle', (event) => {
      if (event.detail.target.id === 'js-boost-target') {
        this._manualScrollHandling()
        this.reinit()
      } else {
        this._autoScrollHandling()
      }

      if (gitRevisionOnLoad !== window.gon.git_revision || !window.gon.boost) {
        const target = document.getElementById('js-boost-target')
        target.setAttribute('hx-boost', 'false')
        console.log('Reboosting...')
      }
    })
  }

  _setup () {
    htmx.on('htmx:beforeRequest', (e) => {
      if (e.detail.elt.dataset.remote === 'true') {
        e.preventDefault()
        e.stopPropagation()
      }
    })

    htmx.on('htmx:historyRestore', (e) => {
      $('.progress-bar').removeClass('progress-bar--loading')
      this.reinit()
    })

    htmx.on('htmx:xhr:loadstart', (e) => {
      $('.progress-bar').addClass('progress-bar--loading')
    })

    htmx.on('htmx:afterRequest', (e) => {
      $('.progress-bar').removeClass('progress-bar--loading')
    })
  }

  _manualScrollHandling () {
    if (window.history.scrollRestoration) {
      window.history.scrollRestoration = 'manual'
    }
  }

  _autoScrollHandling () {
    if (window.history.scrollRestoration) {
      window.history.scrollRestoration = 'auto'
    }
  }
}
